// ======================================================================
// File Name       : ContentQuestionAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import moment from 'moment';
import { DEFAULT_DATE_FORMAT_SERVER, DRILL_QUESTION_SKIN_CLIENT_URL, RETURN_MAX_NUM, SELECT_TARGET_DATA, STRUCTURE_LEVEL } from '../../constants';
import * as ActionTypes from '../../constants/actionTypes/question';
import { ANSWER_FORMULA_NUM } from '../../constants/ContentConstant';
import { escapeHtml } from '../../utils';
import { commonCallApi } from '../../utils/ApiUtils';
import * as contentQuestionCreators from '../actionCreators/question';
import { getAttributeList, sendGetQuestionListFileRequest, sendQuestionImportRequest } from '../httpRequests/content';

export function searchContent({
  questionSecernId,
  questionTitle,
  answerFormula,
  convertStatus,
  questionKind,
  createdDateFrom,
  createdDateTo,
  dataAffiliationType,
  returnMaxNum = RETURN_MAX_NUM,
  questionSortType,
  ascendingDescendingSort,
  startPosition,
  questionAttributeList,
  createdUserName, //Step 9.0.0 
}) {
  return (dispatch) => {
    const questionInfo = {};
    const regDate = {};
    questionSecernId && (questionInfo.questionSecernId = questionSecernId);
    questionTitle && (questionInfo.questionTitle = questionTitle);
    !isNaN(answerFormula) && (questionInfo.answerFormula = parseInt(answerFormula, 10));
    !isNaN(convertStatus) && (questionInfo.convertStatus = parseInt(convertStatus, 10));
    createdDateFrom && (regDate.startDate = moment(createdDateFrom).startOf('day').format(DEFAULT_DATE_FORMAT_SERVER));
    createdDateTo && (regDate.endDate = moment(createdDateTo).endOf('day').format(DEFAULT_DATE_FORMAT_SERVER));
    startPosition !== null && (questionInfo.startPosition = startPosition);
    questionSortType !== null && (questionInfo.questionSortType = questionSortType);
    returnMaxNum !== null && (questionInfo.returnMaxNum = returnMaxNum);
    ascendingDescendingSort !== null &&
      (questionInfo.ascendingDescendingSort = ascendingDescendingSort);
    !isNaN(dataAffiliationType) &&
    parseInt(dataAffiliationType, 10) >= 0 &&
      (questionInfo.dataAffiliationType = parseInt(dataAffiliationType, 10));
    !isNaN(questionKind) &&
    parseInt(questionKind, 10) >= 0 &&
    (questionInfo.questionKind = parseInt(questionKind, 10));
    if (regDate && (regDate.startDate || regDate.endDate)) {
      questionInfo.regDate = regDate;
    }
    questionAttributeList && (questionInfo.questionAttributeList = questionAttributeList);
    createdUserName && (questionInfo.createdUserName = createdUserName); //Step 9.0.0
    return dispatch(getQuestionList({ questionInfo }));
  };
}

function getQuestionList(questionInfo) {
  return dispatch => commonCallApi({
    path: 'QuestionList',
    data: questionInfo,
    drillServer: true,
  }).then(resdata => dispatch(receiveQuestionList(resdata)));
}

function receiveQuestionList({ recordNum, questionList }) {
  return {
    type: ActionTypes.QUESTION_LIST_SEARCH,
    recordNum,
    questionList,
  };
}

export function exportQuestionList({
  questionSecernId,
  questionTitle,
  answerFormula,
  convertStatus,
  createdDateFrom,
  createdDateTo,
  dataAffiliationType,
  questionKind,
  questionAttributeList,
  createdUserName, //Step 9.0.0
}) {
  return (dispatch) => {
    const questionInfo = {};
    const regDate = {};
    questionSecernId && (questionInfo.questionSecernId = questionSecernId);
    questionTitle && (questionInfo.questionTitle = questionTitle);
    !isNaN(answerFormula) && (questionInfo.answerFormula = parseInt(answerFormula, 10));
    !isNaN(convertStatus) && (questionInfo.convertStatus = parseInt(convertStatus, 10));
    !isNaN(dataAffiliationType) &&
    parseInt(dataAffiliationType, 10) >= 0 &&
      (questionInfo.dataAffiliationType = parseInt(dataAffiliationType, 10));
    !isNaN(questionKind) &&
    parseInt(questionKind, 10) >= 0 &&
    (questionInfo.questionKind = parseInt(questionKind, 10));
    createdDateFrom && (regDate.startDate = moment(createdDateFrom).startOf('day').format(DEFAULT_DATE_FORMAT_SERVER));
    createdDateTo && (regDate.endDate = moment(createdDateTo).endOf('day').format(DEFAULT_DATE_FORMAT_SERVER));
    if (regDate && (regDate.startDate || regDate.endDate)) {
      questionInfo.regDate = regDate;
    }
    questionAttributeList && (questionInfo.questionAttributeList = questionAttributeList);
    createdUserName && (questionInfo.createdUserName = createdUserName); //Step 9.0.0
    return dispatch(sendExportRequest({ questionInfo }));
  };
}

function sendExportRequest(questionInfo) {
  return dispatch => commonCallApi({
    path: 'private/QuestionListDownload',
    data: questionInfo,
    drillServer: true,
  });
}

export function getQuestionDetail(questionId) {
  return (dispatch) => {
    const param = {
      questionSecernId: questionId,
    };
    commonCallApi({
      path: 'QuestionDetailInfo',
      data: param,
      drillServer: true,
    }).then((resdata) => {
      dispatch(receiveQuestionDetail(resdata));
    });
  };
}

function receiveQuestionDetail({ questionInfo }) {
  return {
    type: ActionTypes.QUESTION_DETAIL,
    questionInfo,
  };
}

export function deleteQuestionDetail(questionId) {
  const param = {
    questionSecernId: questionId,
  };
  return dispatch => commonCallApi({
    path: 'QuestionDelete',
    data: param,
    drillServer: true,
  }).then((resdata) => {
    dispatch(receiveQuestionDelete());
  });
}

function receiveQuestionDelete() {
  return {
    type: ActionTypes.QUESTION_DELETE,
  };
}

export function updateQuestionSingle({
  questionSecernId,
  questionTitle,
  questionAttributeScope,
  answerFormula,
  sankakuUseDistinct,
  absolutePoint,
  limitTime,
  hintUse,
  hintContent,
  hintHtmlUse,
  hintZipFileName,
  hintZipFile,
  questionUseForm,
  questionViewDirection,
  questionContent,
  questionZipFileName,
  questionZipFile,
  optionMarkKind,
  optionRandomUse,
  correctNumber,
  correctAnswer,
  inputLimit,
  inputLimitType,
  optionArray,
  explanationUse,
  explanationContent,
  explanationHtmlUse,
  explanationZipFileName,
  explanationZipFile,
}) {
  const param = {};
  const questionInfo = {};
  questionSecernId && (questionInfo.questionSecernId = questionSecernId);
  questionTitle && (questionInfo.questionTitle = escapeHtml(questionTitle)); // #6818
  questionAttributeScope && (questionInfo.questionAttributeScope = questionAttributeScope);
  questionInfo.sankakuUseDistinct = !isNaN(sankakuUseDistinct) ? parseInt(sankakuUseDistinct, 10) : 0;
  questionInfo.absolutePoint = !isNaN(absolutePoint) ? parseInt(absolutePoint, 10) : 0;
  questionInfo.limitTime = !isNaN(limitTime) ? parseInt(limitTime, 10) : 0;
  correctNumber && (questionInfo.correctNumber = correctNumber);
  questionInfo.inputLimitType = !isNaN(inputLimitType) ? parseInt(inputLimitType, 10) : 0;
  questionInfo.inputLimit = null;
  if (inputLimitType) {
    questionInfo.inputLimit = parseInt(inputLimit, 10);
  }

  // question
  questionUseForm !== null && (questionInfo.questionUseForm = (questionUseForm == '1' ? 1 : 0));
  if (questionInfo.questionUseForm === 1) {
    questionInfo.questionContent = '';
    questionInfo.questionZipFileName = questionZipFileName;
    param.questionZipFile = questionZipFile;
    questionInfo.answerFormula = null;
    questionInfo.optionMarkKind = 0;
    questionInfo.optionRandomUse = 0;
    questionInfo.optionArray = [];
    questionInfo.questionViewDirection = 0;
    questionInfo.correctAnswer = '';
    questionInfo.correctNumber = '';
  } else {
    questionInfo.questionUseForm = 0;
    questionInfo.questionContent = questionContent;
    questionInfo.questionZipFileName = '';
    param.questionZipFile = '';
    questionViewDirection &&
    (questionInfo.questionViewDirection = parseInt(questionViewDirection, 10));
    !isNaN(optionMarkKind) && (questionInfo.optionMarkKind = parseInt(optionMarkKind, 10));
    !isNaN(optionRandomUse) && (questionInfo.optionRandomUse = (optionRandomUse == '1' ? 1 : 0));
    !isNaN(answerFormula) && (questionInfo.answerFormula = parseInt(answerFormula, 10));

    // check answerFormula = 3,4,5,6,7 set the answer to param correct_answer
    if (!isNaN(questionInfo.answerFormula)) {
      if (questionInfo.answerFormula === ANSWER_FORMULA_NUM.DESCRIPTIVE_SINGLE_ANSWER ||
        questionInfo.answerFormula === ANSWER_FORMULA_NUM.DESCRIPTIVE_SINGLE_ANSWER_LONG_ANSWER ||
        questionInfo.answerFormula === ANSWER_FORMULA_NUM.DESCRIPTIVE_SINGLE_ANSWER_MULTI_CORRECT ||
        questionInfo.answerFormula === ANSWER_FORMULA_NUM.DESCRIPTIVE_MULTIPLE_ANSWER_NO_ORDER ||
        questionInfo.answerFormula === ANSWER_FORMULA_NUM.DESCRIPTIVE_MULTIPLE_ANSWER_ORDER) {
        correctAnswer && (questionInfo.correctAnswer = correctAnswer);
        questionInfo.correctNumber = '';
        questionInfo.optionArray = [];
      } else {
        questionInfo.correctAnswer = '';
        // #6818 START
        if (optionArray) {
          const optionArrayEscapeHtml = optionArray.reduce((acc, cur) => {
            cur.optionContent = escapeHtml(cur.optionContent);
            acc.push(cur);
            return acc;
          }, []);
          questionInfo.optionArray = optionArrayEscapeHtml;
        }
        // #6818 END
        correctNumber && (questionInfo.correctNumber = correctNumber);
      }
    }
  }
  // explanation
  explanationUse !== null && (questionInfo.explanationUse = (explanationUse == '1' ? 1 : 0));
  explanationHtmlUse !== null && questionInfo.explanationUse == 1 && (questionInfo.explanationHtmlUse = (explanationHtmlUse == '1' ? 1 : 0));
  if (questionInfo.explanationUse === 1) {
    if (questionInfo.explanationHtmlUse === 1) {
      param.explanationZipFile = explanationZipFile || undefined;
      questionInfo.explanationZipFileName = explanationZipFileName;
      questionInfo.explanationContent = '';
    } else {
      param.explanationZipFile = '';
      questionInfo.explanationZipFileName = '';
      questionInfo.explanationContent = explanationContent;
      questionInfo.explanationHtmlUse = 0;
    }
  } else {
    questionInfo.explanationUse = 0;
    questionInfo.explanationHtmlUse = 0;
    param.explanationZipFile = '';
    questionInfo.explanationZipFileName = '';
    questionInfo.explanationContent = '';
  }

  // hint
  hintUse !== null && (questionInfo.hintUse = (hintUse == '1' ? 1 : 0));
  hintHtmlUse !== null && questionInfo.hintUse === 1 && (questionInfo.hintHtmlUse = (hintHtmlUse == '1' ? 1 : 0));
  if (questionInfo.hintUse === 1) {
    if (questionInfo.hintHtmlUse === 1) {
      questionInfo.hintContent = '';
      questionInfo.hintZipFileName = hintZipFileName;
      param.hintZipFile = hintZipFile || undefined;
    } else {
      questionInfo.hintContent = hintContent;
      questionInfo.hintZipFileName = '';
      param.hintZipFile = '';
      questionInfo.hintHtmlUse = 0;
    }
  } else {
    questionInfo.hintUse = 0;
    questionInfo.hintContent = '';
    questionInfo.hintZipFileName = '';
    param.hintZipFile = '';
    questionInfo.hintHtmlUse = 0;
  }
  param.questionInfo = questionInfo;
  return (dispatch) => {
    commonCallApi({
      path: 'QuestionUpdate',
      data: param,
      muiltipart: 1,
      drillServer: true,
    }).then((resdata) => {
      dispatch(receiveQuestionUpdate());
    });
  };
}

function receiveQuestionUpdate() {
  return {
    type: ActionTypes.QUESTION_UPDATE,
  };
}

export function updateQuestionBig({
  questionSecernId,
  questionTitle,
  questionAttributeScope,
  hintUse,
  hintContent,
  hintHtmlUse,
  hintZipFileName,
  hintZipFile,
  questionUseForm,
  questionZipFileName,
  questionZipFile,
  explanationUse,
  explanationContent,
  explanationHtmlUse,
  explanationZipFile,
  explanationZipFileName,
  subQuestionArray,
  limitTime,
  questionKind,
}) {
  const param = {};
  const questionInfo = {};
  questionSecernId && (questionInfo.questionSecernId = questionSecernId);
  questionTitle && (questionInfo.questionTitle = questionTitle);
  questionAttributeScope && (questionInfo.questionAttributeScope = questionAttributeScope);
  hintUse !== null && (questionInfo.hintUse = (hintUse == '1' ? 1 : 0));
  hintHtmlUse !== null && (questionInfo.hintHtmlUse = (hintHtmlUse == '1' ? 1 : 0));
  questionInfo.questionUseForm = 1;
  explanationUse !== null && (questionInfo.explanationUse = (explanationUse == '1' ? 1 : 0));
  explanationHtmlUse !== null && (questionInfo.explanationHtmlUse = (explanationHtmlUse == '1' ? 1 : 0));
  subQuestionArray && (questionInfo.subQuestionArray = subQuestionArray);
  questionInfo.limitTime = !isNaN(limitTime) ? parseInt(limitTime, 10) : 0;
  // setting question file
  if (questionInfo.questionUseForm === 1) {
    questionInfo.questionZipFileName = questionZipFileName;
    param.questionZipFile = questionZipFile;
  }
  // setting hint content
  if (questionInfo.hintUse === 1) {
    if (questionInfo.hintHtmlUse === 1) {
      questionInfo.hintContent = '';
      questionInfo.hintZipFileName = hintZipFileName || undefined;
      param.hintZipFile = hintZipFile;
    } else {
      questionInfo.hintHtmlUse = 0;
      questionInfo.hintContent = hintContent;
      questionInfo.hintZipFileName = '';
    }
  } else {
    questionInfo.hintUse = 0;
    questionInfo.hintHtmlUse = 0;
    questionInfo.hintContent = '';
    questionInfo.hintZipFileName = '';
  }
  // setting explanation content
  if (questionInfo.explanationUse === 1) {
    if (questionInfo.explanationHtmlUse === 1) {
      param.explanationZipFile = explanationZipFile || undefined;
      questionInfo.explanationZipFileName = explanationZipFileName;
      questionInfo.explanationContent = '';
    } else {
      questionInfo.explanationHtmlUse = 0;
      questionInfo.explanationZipFileName = '';
      questionInfo.explanationContent = explanationContent;
    }
  } else {
    questionInfo.explanationUse = 0;
    questionInfo.explanationHtmlUse = 0;
    questionInfo.explanationZipFileName = '';
    questionInfo.explanationContent = '';
  }
  param.questionInfo = questionInfo;
  return (dispatch) => {
    commonCallApi({
      path: 'PartsQuestionUpdate',
      data: param,
      muiltipart: 1,
      drillServer: true,
    }).then((resdata) => {
      dispatch(receiveQuestionUpdate());
    });
  };
}

function receiveData(resData, type) {
  return {
    type,
    resData,
  };
}

export function getListImportedFile(options) {
  return (dispatch) => {
    const PARAM_DEFAULT = {
      returnMaxNum: RETURN_MAX_NUM,
    };
    sendGetQuestionListFileRequest(PARAM_DEFAULT, options).then((resdata) => {
      dispatch(receiveFileList(resdata));
    });
  };
}

function receiveFileList({ recordNum, importResultList }) {
  return {
    type: ActionTypes.GET_IMPORTED_FILE_LIST,
    recordNum,
    importResultList,
  };
}

export function importQuestions(data, options) {
  return (dispatch) => {
    sendQuestionImportRequest(data, options).then((resdata) => {
      dispatch(receiveData(resdata, ActionTypes.IMPORT_QUESTION_LIST));
    });
  };
}

export function initContentList(searchCondition) {
  return (dispatch) => {
    const searchList = {};
    if (searchCondition) {
      dispatch(searchContent(searchCondition));
    } else {
      dispatch(searchContent(searchList));
    }
  };
}

export function getAttributeQuestionList() {
  return async (dispatch) => {
    const attributeList = await getAttributeList({ selectTargetData: SELECT_TARGET_DATA.DATA, recursiveType: STRUCTURE_LEVEL.DIRECT });
    return dispatch(
      contentQuestionCreators.getAttributeList(
        attributeList,
      ),
    );
  };
}

export function searchQuestionAttributeList(data) {
  return async (dispatch) => {
    const attributeList = await getAttributeList(data);
    return dispatch(
      contentQuestionCreators.getAttributeListDialog(
        attributeList,
      ),
    );
  };
}

export function createValueAttributeItem() {
  return {
    type: ActionTypes.CREATE_VALUE_ATTRIBUTE_ITEM,
  };
}

export function cachePreviewQuestionSkin() {
  // Create Iframe
  const iframeSource = DRILL_QUESTION_SKIN_CLIENT_URL;
  const iframe = document.createElement('iframe');
  iframe.setAttribute('id', 'question_skin_iframe');
  iframe.setAttribute('class', 'cached_question_skin');
  iframe.setAttribute('frameBorder', '100');
  iframe.setAttribute('scrolling', 'yes');
  iframe.style.position = 'absolute';
  iframe.style.top = '-999px';
  iframe.style.left = '-999px';
  iframe.style.width = '10px';
  iframe.style.height = '5px';
  iframe.src = iframeSource;
  document.body.appendChild(iframe);
}
